import React from 'react';

export const SecurityContext = React.createContext(null);

SecurityContext.displayName = 'Security Context';

export default SecurityContext;